import { observer } from 'mobx-react';
import { useEffect, useRef } from 'react';
import { useAutoScroll } from '../../AutoScrollContext';
import ChatDisplayHistory from './ChatDisplayHistory';
import { autoScrollIfNeeded } from '../../utils';
import { Message } from '../../../ChatStores/ChatStore/Types';

interface ConversationHistoryProps {
  messages: Message[];
}

function ConversationHistory({ messages }: ConversationHistoryProps) {
  const messagesEndRef = useRef<HTMLDivElement | null>(null);
  const { isAutoScrollEnabled } = useAutoScroll();

  useEffect(() => {
    autoScrollIfNeeded(isAutoScrollEnabled, messagesEndRef);
    // eslint-disable-next-line react-hooks/exhaustive-deps -- isAutoScrollEnabled is a guard not a trigger; scroll should only fire on new messages
  }, [messages]);

  return (
    <div>
      {messages.map((message, index) => (
        <ChatDisplayHistory message={message} key={index} />
      ))}
      <div ref={messagesEndRef} />
    </div>
  );
}

export default observer(ConversationHistory);
